export const ResetPasswordErrorCodeEnum = {
  InvalidEmail: 'auth/invalid-email',
  UserNotFound: 'auth/user-not-found',
};


// WEBPACK FOOTER //
// ./src/app/modules/auth/domain/enums/ResetPasswordErrorEnum.ts